<template>
    <div class="content-page">
        <div class="container-fluid add-form-list">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <div class="header-title">
                                <h4 class="card-title">Add a Meal type </h4>
                            </div>
                        </div>
                        <div class="card-body">
                            <form @submit.prevent="store" data-toggle="validator">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Title*</label>
                                            <input type="text" v-model="type.libelle" class="form-control" placeholder="Enter libelle" required>
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Description*</label>
                                            <input type="text" v-model="type.description" class="form-control" placeholder="Enter libelle">
                                        </div>
                                    </div>
                                                              
                                </div> 

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Coût *</label>
                                            <input type="number" v-model="type.price" class="form-control" placeholder="Enter coût">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>  
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Type *</label>
                                            <select class="form-control"  v-model="type.parent_id" id="">
                                                <option  value="0">Aucun</option>
                                                <option v-for="(selectTy,index) in typeSelect" :key="index" :value="selectTy.id">{{selectTy.libelle}}</option>
                                            </select>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>    
                                </div>                      
                                <button type="submit" class="btn btn-primary mr-2">Save</button>
                                <button type="reset" class="btn btn-danger">reinitialiser</button>
                            </form>
                        </div>
                    </div>
                    <div class="vld-parent">
                        <loading :active.sync="isLoading" 
                        :can-cancel="true" 
                        :is-full-page="fullPage"></loading>
                    </div>
                </div>
            </div>
            <!-- Page end  -->
        </div>
    </div>
</template>
<script>
import axios from "axios";
import {URL_API} from '@/config'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Swal from 'sweetalert2'
export default {
    components: {
            Loading
    },
    data() {
        return {permissions: [],
            type:{
                parent_id:0
            },
            typeSelect:[],
            isLoading: false,
            fullPage: true
        };
    },
    mounted(){
        this.$store.state.user.permissions.forEach(element => {
            this.permissions.push(element.name)
        });
        this.getTypes()
    },
    methods:{

        store() {
            this.isLoading = true
            axios.post(URL_API+'types-repas', this.type)
            .then(response => {
                
                console.log(response.data)
                this.isLoading = false
                
                if (response.data.status) {
                    Swal.fire(
                        'Done!',
                        'The Meal type  was created successfully..',
                        'success'
                    )
                    this.$router.push('/index-types-repas')
                }
            })
            .catch(error => {
                console.log(error)
                this.errored = true
                this.isLoading = false
            })
        },
        getTypes() {
            this.isLoading = true
            axios.get(URL_API+'types-repas', this.type)
            .then(response => {
                
                console.log(response.data)
                this.isLoading = false
                
                if (response.data.status) {
                    this.typeSelect =  response.data.data
                }
            })
            .catch(error => {
                console.log(error)
                this.errored = true
                this.isLoading = false
            })
        },
    }
}
</script>